export default __webpack_public_path__ + "static/media/Copperplate.0e1d4a12.ttf";